import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import Navbar from "../navbar/Navbar";
import Sidemenu from "../sidemenu/Sidemenu";
import {Typography, Grid2, Box, AppBar, Tab, Tabs, Button, Grid, TableBody, TableCell, TableContainer, Table, TableHead, TableRow, TableSortLabel, Avatar, Select, MenuItem} from '@mui/material';
import newUser from '../../assets/icons/newUserIcon.svg';
import totalRideIcon from '../../assets/icons/vehicle.svg';
import increment from '../../assets/icons/increment.svg';
import decrement from '../../assets/icons/decrement.svg';
import CancelledRideIcon from '../../assets/icons/cancelledRide.svg';
import activeRidesIcon from '../../assets/icons/activeRides.svg';
import earningsIcon from '../../assets/icons/earningsIcon.svg';
import prevIcon from '../../assets/icons/left-arrow.svg'
import nextIcon from '../../assets/icons/right-arrow.svg';
import { useState } from "react";
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LineChart } from '@mui/x-charts/LineChart';
import axios from 'axios';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import config from '../../config/config.js';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
// import { GoogleMap, useJsApiLoader, DirectionsRenderer, Polygon, DrawingManager, Marker } from '@react-google-maps/api';
import latLngMarker from '../../assets/icons/latLngMark.svg';
import constants from '../../constant.js';
import { useNavigate } from 'react-router-dom';
import mapPin from '../../assets/icons/LocationPin.svg';
import { GoogleMap, Marker } from "@react-google-maps/api";
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";
import ShuttleDashboard from '../shuttleDashboard/ShuttleDashboard';
import AnimatedCount from './AnimateCount';

const LIBRARIES = ["maps", "drawing", "places", "geometry"];

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other} >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
  
function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function a11yDownloadProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function a11yPropsBooking(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function a11yPropsLatestUser(index){
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
      };
}

const MainDashboard = () => {
    const theme = useTheme();
    const serverUrl = config.serverUrl;
    const currentDate = dayjs(); // Get the current date
    const sevenDayBefore = currentDate.subtract(7, 'day'); 
    const [value, setValue] = useState(0);

    const clientDemoType = localStorage.getItem('clientDemoType');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);

    const [driverStatsVal, setDriverStatsVal] = useState("1");
    const [downloadStatsVal, setDownloadStatsVal] = useState("1");
    const [downloadTab, setDownloadTab] = useState(0);
    const [bookingTab, setBookingTab] = useState(0);
    const [bookingStartDate, setBookingStartDate] = React.useState(sevenDayBefore); // Default start date
    const [bookingEndDate, setBookingEndDate] = React.useState(currentDate);
    const [headerPeriod, setHeaderPeriod] = useState(1);      //card Details Period
    const [headerData, setHeaderData] = useState([]);      //card Details Data
    const [prevHeaderData, setPrevHeaderData] = useState([]);
    const [chartData, setChartData] = useState(null);
    const [downloadChartData, setDownloadChartData] = useState(null);
    const [bookingChartData, setBookingChartData] = useState(null);
    const [latestUserTab, setLatestUserTab] = useState(0);
    const [latestUserData, setLatestUserData] = useState(null);
    const [driverEarningVal, setDriverEarningVal] = useState("1");
    const [earningChartData, setEarningChartData] = useState(null);
    const [clientDemoTypeFilter, setClientDemoTypeFilter] = useState(clientDemoType ==2 ? "2" : "1");

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('vehicleName');
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginatedData, setPaginatedData] = useState([]);
    const [latLngData, setLatLngData] = useState([]);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [bound, setBound] = useState(false);
    const [mapInstance, setMapInstance] = useState(null);
    const navigate = useNavigate();

    const [changedKeys, setChangedKeys] = useState([]); // ⬅️ stores changed flags per key
    const previousCountsRef = React.useRef({}); // ⬅️ stores previous counts
    const [animateOnUpdate, setAnimateOnUpdate] = React.useState(false);
    const dashboard_auto_refresh = localStorage.getItem('dashboard_auto_refresh');
    const driver_earning_enabled = localStorage.getItem('remove_driver_earnings_from_dashboard') === '1';
    const [showDriverEarnings, setShowDriverEarnings] = useState(!driver_earning_enabled);
    React.useEffect(() => {
        if (mapInstance && latLngData && latLngData.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            latLngData.forEach((point) =>
                bounds.extend({ lat: point.lat, lng: point.lng })
            );
            mapInstance.fitBounds(bounds);
        }
    }, [latLngData, bound]);

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleUserStaticsChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleDownloadStaticsChange = (event, newValue) => {
        setDownloadTab(newValue);
    };

    const handleBookingStaticsChange = (event, newValue) => {
        setBookingTab(newValue);
    };

    const handleLatestUserChange = (event, newValue) => {
        setLatestUserTab(newValue);
    };

    const driverStaticsValue = (text) => {
        setDriverStatsVal(text);
    }

    const downloadStaticsValue = (text) => {
        setDownloadStatsVal(text);
    }

    const driverEarningStaticsValue = (text) => {
        setDriverEarningVal(text);
    }

    const chartSetting = {
        yAxis: [
          {
            label: 'rainfall (mm)',
          },
        ],
        width: 500,
        height: 300,
        sx: {
          [`.${axisClasses.left} .${axisClasses.label}`]: {
            transform: 'translate(-20px, 0)',
          },
        },
    };

    const handleInputChange = (e) => {
        setHeaderPeriod(e.target.value);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    
    React.useEffect(() => {
        if (headerData) {
            // console.log('Updated headerData:', headerData);
            // setPrevHeaderData(headerData);
        }
    }, [headerData]);

    //fetching header card details
    const fetchCarDetailsData = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/dashboard/card_details`;
            const obj={
                token: token, timestamp: timestamp, period: headerPeriod, city_id: cityFilter
            }

            const response =  await makeGetRequestToUrl(url, obj);

            if (response.flag === 200 && response.data) {
                const newData = response.data || {};
                const prevData = previousCountsRef.current || {};
            
                const changed = {};
                if(animateOnUpdate){
                    for (const key in newData) {
                        const newVal = newData[key];
                        const prevVal = prevData[key];
                
                        // engagementCardDetails is nested, handle it specially
                        if (key === 'engagementCardDetails' && newVal && prevVal) {
                            for (const nestedKey in newVal) {
                                if (newVal[nestedKey]?.count !== prevVal[nestedKey]?.count) {
                                    if (!changed[key]) changed[key] = {};
                                    changed[key][nestedKey] = true;
                                }
                            }
                        } else {
                            // For simple top-level keys like customerCardDetails and driverCardDetails
                            if (newVal?.count !== prevVal?.count) {
                                changed[key] = true;
                            }
                        }
                    }
                }
            
                console.log('changed = ', changed);
            
                setChangedKeys(changed);
                setHeaderData(response.data);
                if(headerData){
                    setPrevHeaderData(headerData);
                    console.log('prevHeaderData = ', headerData);
                }
            
                previousCountsRef.current = newData;
            }
            
            
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    React.useEffect(() => {
        if (clientDemoType === '1' || clientDemoType === '3') {
            setAnimateOnUpdate(false);
            fetchCarDetailsData();
        }
    }, [headerPeriod, cityFilter]);

    React.useEffect(() => {
        if(clientDemoTypeFilter==1 && dashboard_auto_refresh!='undefined' && dashboard_auto_refresh != null && parseInt(dashboard_auto_refresh)!=0){
            const intervalMs = parseInt(dashboard_auto_refresh) * 1000;
            const intervalId = setInterval(() => {
                setAnimateOnUpdate(true);
                fetchCarDetailsData();
            }, intervalMs);

            return () => {
                clearInterval(intervalId);
            }
        }
    }, [fetchCarDetailsData, dashboard_auto_refresh]);

    React.useEffect(() => {
        if (chartData) {
            // console.log('Updated chartData:', chartData);
        }
    }, [chartData]);
    //fetching rider and driver statics
    React.useEffect(() => {
        const fetchUserStatisticsData = async () => {
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();

                const url = `${serverUrl}/dashboard/user_statistics`;
                const obj={
                    token: token, timestamp: timestamp, period: driverStatsVal, is_driver: value==0 ? 1 : 0, city_id: cityFilter
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    const userStatisticsData = response.data;

                    // Use Object.keys for days (x-axis labels)
                    const labels = Object.keys(userStatisticsData); // ['Mon', 'Tues', ...]

                    // Use Object.values for data array (values for each day)
                    const labelsData = Object.values(userStatisticsData); // [{ total: ..., active: ... }, ...]

                    // Extract data series for each metric (e.g., total, active, etc.)
                    const metricKeys = labelsData.length > 0 ? Object.keys(labelsData[0]) : [];
                    const formattedSeriesData = metricKeys.length > 0 
                        ? metricKeys.map(metric => ({
                            name: metric,
                            data: labels.map(day => userStatisticsData[day][metric])
                        }))
                        : [];

                    // Set chart data
                    setChartData({
                        labels: labels, // Use dynamic labels as needed
                        seriesData: formattedSeriesData
                    });
                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                    // navigate('/signup');
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if(clientDemoType === '1' || clientDemoType === '3'){
            fetchUserStatisticsData();
        }
    }, [value, driverStatsVal, cityFilter]);


    //fetching ios and android download statics
    React.useEffect(() => {
        const fetchDownloadStatisticsData = async () => {
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();

                const url = `${serverUrl}/dashboard/download_statistics`;
                const obj={
                    token: token, timestamp: timestamp, period: downloadStatsVal, is_driver: downloadTab==0 ? 1 : 0, city_id: cityFilter
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    const downloadStatisticsData = response.data;

                    // Use Object.keys for days (x-axis labels)
                    const labels = Object.keys(downloadStatisticsData); // ['Mon', 'Tues', ...]

                    // Use Object.values for data array (values for each day)
                    const labelsData = Object.values(downloadStatisticsData); // [{ total: ..., active: ... }, ...]

                    // Extract data series for each metric (e.g., total, active, etc.)

                    const metricKeys = labelsData.length > 0 ? Object.keys(labelsData[0]) : [];
                    const formattedSeriesData = metricKeys.length > 0 
                        ? metricKeys.map(metric => ({
                            name: metric,
                            data: labels.map(day => downloadStatisticsData[day][metric])
                        }))
                        : [];

                    // Set chart data
                    setDownloadChartData({
                        labels: labels, // Use dynamic labels as needed
                        seriesData: formattedSeriesData
                    });

                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                    // navigate('/signup');
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if(clientDemoType === '1' || clientDemoType === '3'){
            fetchDownloadStatisticsData();
        }
    }, [downloadTab, downloadStatsVal, cityFilter]);

    React.useEffect(() => {
        const fetchLatestUserData = async () => {
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();

                const url = `${serverUrl}/dashboard/latest_users`;
                const obj={
                    token: token, timestamp: timestamp, is_driver: latestUserTab==0 ? 1: 0, city_id: cityFilter
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    setLatestUserData(response.data);
                    setRows(response.data)
                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                    // navigate('/signup');
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if(clientDemoType === '1' || clientDemoType === '3'){
            fetchLatestUserData();
        }
    },[latestUserTab, cityFilter]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    React.useEffect(() => {
        const paginated = Array.isArray(rows)
            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : [];
        setPaginatedData(paginated);
    }, [rows, page, rowsPerPage]);

    //fetching booking statics for different types of rides
    React.useEffect(() => {
        const fetchBookingStatisticsData = async () => {
            try {
                const token = localStorage.getItem('token');
                const stDate = formatDate(bookingStartDate);
                const endDate = formatDate(bookingEndDate);
                const timestamp = new Date().getTime();
            
                const url = `${serverUrl}/dashboard/booking_statistics`;
                const obj={
                    token: token, timestamp: timestamp, 
                    // eng_status: bookingTab==0 ? constants.panelengagmentStatus.COMPLETED : bookingTab==1 ? constants.panelengagmentStatus.ONGOING : bookingTab==2 ? constants.panelengagmentStatus.CANCELLED : 1,
                    start_date: stDate,
                    end_date: endDate,
                    city_id: cityFilter
                }
                if(bookingTab==0){
                    obj['is_scheduled'] = 1;
                }
                else if(bookingTab==1){
                    obj['is_scheduled'] = 0;
                }
                else if(bookingTab==2){ //completed
                    obj['eng_status'] = 2;
                }
                else { //3-cancelled
                    obj['eng_status'] = 3;
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    const bookingStatisticsData = response.data;

                    const xAxisData = bookingStatisticsData.map(item => new Date(item.date).toLocaleDateString('en-CA'));
                    const seriesData = bookingStatisticsData.map(item => item.total_count);

                    setBookingChartData({
                        labels: xAxisData,
                        seriesData: seriesData
                    });

                    const latLngArray = [];
                    bookingStatisticsData.forEach((day) => {
                        day.requests.forEach((request) => {
                            latLngArray.push({
                                id: request.request_id,
                                lat: parseFloat(request.pickup_latitude), // Convert latitude to number
                                lng: parseFloat(request.pickup_longitude), // Convert longitude to number
                            });
                        });
                    });

                    setLatLngData(latLngArray);
                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                    // navigate('/signup');
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if(clientDemoType === '1' || clientDemoType === '3'){
            fetchBookingStatisticsData();
        }
    }, [bookingTab, bookingStartDate, bookingEndDate, cityFilter]);

    const { isLoaded, loadError } = useGoogleMapsLoader();

    const containerStyle = {
        width: '98%',
        height: '500px',
      };
    const center = {
        // lat: 28.644800, lng: 77.216721
        lat: latLngData ? latLngData.reduce((sum, point) => sum + point.lat, 0) / latLngData.length : 0,
        lng: latLngData ? latLngData.reduce((sum, point) => sum + point.lng, 0) / latLngData.length : 0,
    };

    const onLoad = React.useCallback(function callback(map) {
        // const bounds = new window.google.maps.LatLngBounds()
        // map.fitBounds(bounds)
        setMapInstance(map);
    }, []);
    
    const onUnmount = React.useCallback(function callback(map) {
        // console.log('unmounting');
        setMapInstance(null);
    }, []);

    React.useEffect(() => {
        const fetchDriverEarningsData = async () => {
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();

                const url = `${serverUrl}/dashboard/driver_earning_statistics`;
                const obj={
                    token: token, timestamp: timestamp, period: driverEarningVal, city_id: cityFilter
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    const driverEarningStatics = response.data;

                    const xAxisData = Object.keys(driverEarningStatics);
                    const seriesData = xAxisData.map(day => driverEarningStatics[day].total_earnings);

                    setEarningChartData({
                        labels: xAxisData,
                        seriesData: seriesData
                    });
                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                    // navigate('/signup');
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if(clientDemoType === '1' || clientDemoType === '3'){
            fetchDriverEarningsData();
        }
    },[driverEarningVal, cityFilter]);


    return(
        <div>
           <Grid2 container>
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Dashboard</Typography>
            <Grid2 item sx={{marginLeft:'auto', display:'flex', alignItems:'center', gap:1}}>
                 <Grid2 item>
                    <Select displayEmpty value={cityFilter}
                        onChange={(e) => setCityFilter(e.target.value)}
                        style={{ width: '180px', height: '42px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}
                    >
                        <MenuItem value="" disabled>Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_id} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Select value={clientDemoTypeFilter} 
                    onChange={(e) => setClientDemoTypeFilter(e.target.value)} displayEmpty
                    style={{width: '180px',height:'42px',borderRadius:'8px',backgroundColor: '#FFFFFF'}}>
                        {(clientDemoType === '1' || clientDemoType === '3') && <MenuItem value="1">Ryde</MenuItem>}
                        {(clientDemoType === '2' || clientDemoType === '3') && <MenuItem value="2">Shuttle</MenuItem>}
                </Select>
            </Grid2>
           </Grid2>

            {clientDemoTypeFilter === '1' && (
                <>
                <Grid2 className="mainBox" sx={{marginTop:'1%'}}>
                    <Grid2 sx={{display:'flex',justifyContent:'space-between'}}>
                        <Grid2 item>
                            <select style={{minWidth:'180px', padding:'1%', borderRadius:'10px', minHeight:'42px'}} value={headerPeriod} onChange={handleInputChange}>
                                <option value="1">Today</option>
                                <option value="2">Last 7 Days</option>
                                <option value="3">Last 30 Days</option>
                            </select>
                        </Grid2>
                        <Grid2 item sx={{bgcolor:'#edf8fc', borderRadius:'8px', padding:'6px 12px', display:'flex', alignItems:'center', justifyContent:'center', width: 'calc(25% - 15px)', minWidth: '200px'}}>
                            <Typography sx={{fontSize:'16px', fontWeight:'500'}}>No driver found : <b>{headerData.engagementCardDetails?.NO_DRIVER_AVAILABLE?.count}</b></Typography>
                        </Grid2>
                    </Grid2>

                    {/* Horizontal Scroll Container */}
                    <Grid2
                        container
                        sx={{
                            marginTop: '1%',
                            display: 'grid',
                            gridTemplateColumns: 'repeat(4, 1fr)', // 4 cards per row
                            gap: '20px', // Space between cards
                        }}
                    >
                        {/* Card 1: Total Rides */}
                        <Grid2
                            item
                            sx={{
                                backgroundColor: '#F3F8FF',
                                padding: '1%',
                                borderRadius: '12px',
                                minHeight: '150px',
                            }}
                        >
                            <img src={totalRideIcon} alt="totalRideIcon" />
                            <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Total Rides</Typography>
                            {headerData?.engagementCardDetails?.TOTAL && (
                                <Typography sx={{ fontSize: '24px', color: '#1A1E25', fontWeight: '600', marginTop: '4px' }}>
                                    {animateOnUpdate && !!changedKeys.engagementCardDetails?.TOTAL ? (
                                    <AnimatedCount
                                        target={headerData.engagementCardDetails?.TOTAL?.count}
                                        startVl={prevHeaderData.engagementCardDetails?.TOTAL?.count}
                                        shouldAnimate={true}
                                    />
                                    ) : (
                                    // Plain number with no animation
                                    headerData.engagementCardDetails?.TOTAL?.count ?? 0
                                    )}
                                </Typography>
                              
                            )}
                            <Grid2 item sx={{ display: 'flex', alignItems: 'center', marginTop: animateOnUpdate && !!changedKeys.engagementCardDetails?.TOTAL ? '8px' : 0 }}>
                                {headerData?.engagementCardDetails?.TOTAL?.change >= 0 ? (
                                    <img src={increment} alt="increment" />
                                ) : (
                                    <img src={decrement} alt="decrement" />
                                )}
                                {headerData?.engagementCardDetails?.TOTAL && (
                                    <Typography
                                        sx={{
                                            color:
                                                headerData.engagementCardDetails.TOTAL.change >= 0
                                                    ? '#0DBA78'
                                                    : '#D14545',
                                            fontSize: '12px',
                                            marginTop: '8px',
                                            marginLeft: '4px',
                                        }}
                                    >
                                        {headerData.engagementCardDetails.TOTAL.change}%
                                    </Typography>
                                )}
                            </Grid2>
                        </Grid2>

                        {/* Card 2: Cancelled Rides */}
                        <Grid2
                            item
                            sx={{
                                backgroundColor: '#FFF5F5',
                                padding: '1%',
                                borderRadius: '12px',
                                minHeight: '150px',
                            }}
                        >
                            <img src={CancelledRideIcon} alt="cancelledRideIcon" />
                            <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Cancelled Rides</Typography>
                            {headerData?.engagementCardDetails?.CANCELLED_BY_CUSTOMER && (
                                <Typography sx={{ fontSize: '24px', color: '#1A1E25', fontWeight: '600', marginTop: '4px' }}>
                                    {animateOnUpdate && !!changedKeys.engagementCardDetails?.CANCELLED_BY_CUSTOMER ? (
                                    <AnimatedCount
                                        target={headerData.engagementCardDetails?.CANCELLED_BY_CUSTOMER?.count}
                                        startVl={prevHeaderData.engagementCardDetails?.CANCELLED_BY_CUSTOMER?.count}
                                        shouldAnimate={true}
                                    />
                                    ) : (
                                    // Plain number with no animation
                                    <>
                                        {headerData.engagementCardDetails?.CANCELLED_BY_CUSTOMER?.count ?? 0}
                                    </>
                                    )}
                                </Typography>
                            )}
                            <Grid2 item sx={{ display: 'flex', alignItems: 'center', marginTop: animateOnUpdate && !!changedKeys.engagementCardDetails?.CANCELLED_BY_CUSTOMER ? '8px' : 0}}>
                                {headerData?.engagementCardDetails?.CANCELLED_BY_CUSTOMER?.change >= 0 ? (
                                    <img src={increment} alt="increment" />
                                ) : (
                                    <img src={decrement} alt="decrement" />
                                )}
                                {headerData?.engagementCardDetails?.CANCELLED_BY_CUSTOMER && (
                                    <Typography
                                        sx={{
                                            color:
                                                headerData.engagementCardDetails.CANCELLED_BY_CUSTOMER.change >= 0
                                                    ? '#0DBA78'
                                                    : '#D14545',
                                            fontSize: '12px',
                                            marginTop: '8px',
                                            marginLeft: '4px',
                                        }}
                                    >
                                        {headerData.engagementCardDetails.CANCELLED_BY_CUSTOMER.change}%
                                    </Typography>
                                )}
                            </Grid2>
                        </Grid2>

                        {/* Active Rides Card */}
                        <Grid2
                            item
                            sx={{
                                backgroundColor: '#FFFBF0',
                                padding: '1%',
                                borderRadius: '12px',
                                minHeight: '150px',
                            }}
                        >
                            <img src={activeRidesIcon} alt="Active Rides Icon" />
                            <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Active Rides</Typography>
                            {headerData?.engagementCardDetails?.STARTED && (
                                <Typography sx={{ fontSize: '24px', color: '#1A1E25', fontWeight: '600', marginTop: '4px' }}>

                                    {animateOnUpdate && !!changedKeys.engagementCardDetails?.STARTED ? (
                                    <AnimatedCount
                                        target={headerData.engagementCardDetails?.STARTED?.count}
                                        startVl={prevHeaderData.engagementCardDetails?.STARTED?.count}
                                        shouldAnimate={true}
                                    />
                                    ) : (
                                    // Plain number with no animation
                                    headerData.engagementCardDetails?.STARTED?.count ?? 0
                                    )}
                                </Typography>
                            )}
                            <Grid2 item sx={{ display: 'flex', alignItems: 'center', marginTop: animateOnUpdate && !!changedKeys.engagementCardDetails?.STARTED ? '8px' : 0 }}>
                                {headerData?.engagementCardDetails?.STARTED?.change >= 0 ? (
                                    <img src={increment} alt="Increment Icon" />
                                ) : (
                                    <img src={decrement} alt="Decrement Icon" />
                                )}
                                {headerData?.engagementCardDetails?.STARTED && (
                                    <Typography
                                        sx={{
                                            color:
                                                headerData.engagementCardDetails.STARTED.change >= 0
                                                    ? '#0DBA78'
                                                    : '#D14545',
                                            fontSize: '12px',
                                            marginTop: '8px',
                                            marginLeft: '4px',
                                        }}
                                    >
                                        {headerData.engagementCardDetails.STARTED.change}%
                                    </Typography>
                                )}
                            </Grid2>
                        </Grid2>

                        {/* Rejected Rides Card */}
                        <Grid2
                            item
                            sx={{
                                backgroundColor: '#FFFBF0',
                                padding: '1%',
                                borderRadius: '12px',
                                minHeight: '150px',
                            }}
                        >
                            <img src={activeRidesIcon} alt="Active Rides Icon" />
                            <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Rejected Rides</Typography>
                            {headerData?.engagementCardDetails?.REJECTED_DRIVER_RIDES && (
                                <Typography sx={{ fontSize: '24px', color: '#1A1E25', fontWeight: '600', marginTop: '4px' }}>
                                    {animateOnUpdate && !!changedKeys.engagementCardDetails?.REJECTED_DRIVER_RIDES ? (
                                    <AnimatedCount
                                        target={headerData.engagementCardDetails?.REJECTED_DRIVER_RIDES?.count}
                                        startVl={prevHeaderData.engagementCardDetails?.REJECTED_DRIVER_RIDES?.count}
                                        shouldAnimate={true}
                                    />
                                    ) : (
                                    // Plain number with no animation
                                    headerData.engagementCardDetails?.REJECTED_DRIVER_RIDES?.count ?? 0
                                    )}
                                </Typography>
                            )}
                            <Grid2 item sx={{ display: 'flex', alignItems: 'center', marginTop: animateOnUpdate && !!changedKeys.engagementCardDetails?.REJECTED_DRIVER_RIDES ? '8px' : 0 }}>
                                {headerData?.engagementCardDetails?.REJECTED_DRIVER_RIDES?.change >= 0 ? (
                                    <img src={increment} alt="Increment Icon" />
                                ) : (
                                    <img src={decrement} alt="Decrement Icon" />
                                )}
                                {headerData?.engagementCardDetails?.REJECTED_DRIVER_RIDES && (
                                    <Typography
                                        sx={{
                                            color:
                                                headerData.engagementCardDetails.REJECTED_DRIVER_RIDES.change >= 0
                                                    ? '#0DBA78'
                                                    : '#D14545',
                                            fontSize: '12px',
                                            marginTop: '8px',
                                            marginLeft: '4px',
                                        }}
                                    >
                                        {headerData.engagementCardDetails.REJECTED_DRIVER_RIDES.change}%
                                    </Typography>
                                )}
                            </Grid2>
                        </Grid2>

                        {/* Ended Rides */}
                        <Grid2
                            item
                            sx={{
                                backgroundColor: '#F3F8FF',
                                padding: '1%',
                                borderRadius: '12px',
                                minHeight: '150px',
                            }}
                        >
                            <img src={totalRideIcon} alt="totalRideIcon" />
                            <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Ended Rides</Typography>
                            {headerData?.engagementCardDetails?.ENDED && (
                                <Typography sx={{ fontSize: '24px', color: '#1A1E25', fontWeight: '600', marginTop: '4px' }}>
                                    {animateOnUpdate && !!changedKeys.engagementCardDetails?.ENDED ? (
                                    <AnimatedCount
                                        target={headerData.engagementCardDetails?.ENDED?.count}
                                        startVl={prevHeaderData.engagementCardDetails?.ENDED?.count}
                                        shouldAnimate={true}
                                    />
                                    ) : (
                                    // Plain number with no animation
                                    headerData.engagementCardDetails?.ENDED?.count ?? 0
                                    )}
                                </Typography>
                            )}
                            <Grid2 item sx={{ display: 'flex', alignItems: 'center', marginTop: animateOnUpdate && !!changedKeys.engagementCardDetails?.ENDED ? '8px' : 0 }}>
                                {headerData?.engagementCardDetails?.ENDED?.change >= 0 ? (
                                    <img src={increment} alt="increment" />
                                ) : (
                                    <img src={decrement} alt="decrement" />
                                )}
                                {headerData?.engagementCardDetails?.ENDED && (
                                    <Typography
                                        sx={{
                                            color:
                                                headerData.engagementCardDetails.ENDED.change >= 0
                                                    ? '#0DBA78'
                                                    : '#D14545',
                                            fontSize: '12px',
                                            marginTop: '8px',
                                            marginLeft: '4px',
                                        }}
                                    >
                                        {headerData.engagementCardDetails.ENDED.change}%
                                    </Typography>
                                )}
                            </Grid2>
                        </Grid2>

                        {/* Missed Rides Card */}
                        <Grid2
                            item
                            sx={{
                                backgroundColor: '#FFFBF0',
                                padding: '1%',
                                borderRadius: '12px',
                                minHeight: '150px',
                            }}
                        >
                            <img src={activeRidesIcon} alt="Active Rides Icon" />
                            <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Missed Requests</Typography>
                            {headerData?.engagementCardDetails?.MISSED_DRIVER_RIDES && (
                                <Typography sx={{ fontSize: '24px', color: '#1A1E25', fontWeight: '600', marginTop: '4px' }}>
                                    {animateOnUpdate && !!changedKeys.engagementCardDetails?.MISSED_DRIVER_RIDES ? (
                                    <AnimatedCount
                                        target={headerData.engagementCardDetails?.MISSED_DRIVER_RIDES?.count}
                                        startVl={prevHeaderData.engagementCardDetails?.MISSED_DRIVER_RIDES?.count}
                                        shouldAnimate={true}
                                    />
                                    ) : (
                                    // Plain number with no animation
                                    headerData.engagementCardDetails?.MISSED_DRIVER_RIDES?.count ?? 0
                                    )}
                                </Typography>
                            )}
                            <Grid2 item sx={{ display: 'flex', alignItems: 'center', marginTop: animateOnUpdate && !!changedKeys.engagementCardDetails?.MISSED_DRIVER_RIDES ? '8px': 0 }}>
                                {headerData?.engagementCardDetails?.MISSED_DRIVER_RIDES?.change >= 0 ? (
                                    <img src={increment} alt="Increment Icon" />
                                ) : (
                                    <img src={decrement} alt="Decrement Icon" />
                                )}
                                {headerData?.engagementCardDetails?.MISSED_DRIVER_RIDES && (
                                    <Typography
                                        sx={{
                                            color:
                                                headerData.engagementCardDetails.MISSED_DRIVER_RIDES.change >= 0
                                                    ? '#0DBA78'
                                                    : '#D14545',
                                            fontSize: '12px',
                                            marginTop: '8px',
                                            marginLeft: '4px',
                                        }}
                                    >
                                        {headerData.engagementCardDetails.MISSED_DRIVER_RIDES.change}%
                                    </Typography>
                                )}
                            </Grid2>
                        </Grid2>

                        {/* New Customers Card */}
                        <Grid2
                            item
                            sx={{
                                backgroundColor: '#EFFBF7',
                                padding: '1%',
                                borderRadius: '12px',
                                minHeight: '150px',
                            }}
                        >
                            <img src={earningsIcon} alt="New Customers Icon" />
                            <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>New Customers</Typography>
                            {headerData?.customerCardDetails && (
                                <Typography sx={{ fontSize: '24px', color: '#1A1E25', fontWeight: '600', marginTop: '4px' }}>
                                    {animateOnUpdate && !!changedKeys.customerCardDetails ? (
                                    <AnimatedCount
                                        target={headerData.customerCardDetails?.count}
                                        startVl={prevHeaderData.customerCardDetails?.count}
                                        shouldAnimate={true}
                                    />
                                    ) : (
                                    // Plain number with no animation
                                    headerData.customerCardDetails?.count ?? 0
                                    )}
                                </Typography>
                            )}
                            
                            <Grid2 item sx={{ display: 'flex', alignItems: 'center', marginTop: animateOnUpdate && !!changedKeys.customerCardDetails ? '8px': 0 }}>
                                {headerData?.customerCardDetails?.change >= 0 ? (
                                    <img src={increment} alt="Increment Icon" />
                                ) : (
                                    <img src={decrement} alt="Decrement Icon" />
                                )}
                                {headerData?.customerCardDetails && (
                                    <Typography
                                        sx={{
                                            color:
                                                headerData.customerCardDetails.change >= 0
                                                    ? '#0DBA78'
                                                    : '#D14545',
                                            fontSize: '12px',
                                            marginTop: '8px',
                                            marginLeft: '4px',
                                        }}
                                    >
                                        {headerData.customerCardDetails.change}%
                                    </Typography>
                                )}
                            </Grid2>
                        </Grid2>

                        {/* New Drivers Card */}
                        <Grid2
                            item
                            sx={{
                                backgroundColor: '#F3F8FF',
                                padding: '1%',
                                borderRadius: '12px',
                                minHeight: '150px',
                            }}
                        >
                            <img src={newUser} alt="New Drivers Icon" />
                            <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>New Drivers</Typography>
                            {headerData?.driverCardDetails && (
                                <Typography sx={{ fontSize: '24px', color: '#1A1E25', fontWeight: '600', marginTop: '4px' }}>
                                    {animateOnUpdate && !!changedKeys.driverCardDetails ? (
                                    <AnimatedCount
                                        target={headerData.driverCardDetails?.count}
                                        startVl={prevHeaderData.driverCardDetails?.count}
                                        shouldAnimate={true}
                                    />
                                    ) : (
                                    // Plain number with no animation
                                    headerData.driverCardDetails?.count ?? 0
                                    )}
                                </Typography>
                            )}
                            <Grid2 item sx={{ display: 'flex', alignItems: 'center', marginTop: animateOnUpdate && !!changedKeys.driverCardDetails ? '8px' : 0 }}>
                                {headerData?.driverCardDetails?.change >= 0 ? (
                                    <img src={increment} alt="Increment Icon" />
                                ) : (
                                    <img src={decrement} alt="Decrement Icon" />
                                )}
                                {headerData?.driverCardDetails && (
                                    <Typography
                                        sx={{
                                            color: headerData.driverCardDetails.change >= 0 ? '#0DBA78' : '#D14545',
                                            fontSize: '12px',
                                            marginTop: '8px',
                                            marginLeft: '4px',
                                        }}
                                    >
                                        {headerData.driverCardDetails.change}%
                                    </Typography>
                                )}
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Grid2>

                <Grid2 container size={12} spacing={2}>

                    <Grid2 item size={6} className="mainBox" sx={{marginTop:'1%'}}>
                        <Grid2 item container size={12}>
                            <Grid2 item size={6}>
                                <Typography sx={{fontSize:'24px', color:'#1A1E25', paddingTop:'1%'}}>User's Statistics</Typography>
                            </Grid2>
                            <Grid2 item size={6}>

                                    <AppBar position="static" sx={{minHeight:"10px", maxHeight:'48px', borderRadius:'8px', backgroundColor:'#F9F9F9', padding:'4px', boxShadow:'none'}}>
                                        <Tabs value={value}onChange={handleUserStaticsChange} indicatorColor="secondary"
                                        textColor="inherit" variant="fullWidth" aria-label="full width tabs example" >
                                            <Tab label="Driver Statics" className={value === 0 ? 'tabHeader active' : 'tabHeader'}
                                                sx={{textTransform:'none'}} {...a11yProps(0)} />

                                            <Tab label="Rider Statics" className={value === 1 ? 'tabHeader active' : 'tabHeader'}
                                            sx={{textTransform:'none'}} {...a11yProps(1)} />
                                        </Tabs>
                                    </AppBar>
                            </Grid2>
                        </Grid2> 
                        <hr/>

                        <Grid2>
                            <Grid2 item>

                                <Grid2 container>
                                    <Grid2 item sx={{marginLeft:'auto'}}>
                                        <Button className = {`daysWeeklyMonthly ${driverStatsVal === '1' ? 'active' : ''}`}
                                        onClick={()=>driverStaticsValue('1')}>Days</Button>

                                        <Button className={`daysWeeklyMonthly ${driverStatsVal === '2' ? 'active' : ''}`} 
                                        onClick={()=>driverStaticsValue('2')}>Weekly</Button>

                                        <Button className={`daysWeeklyMonthly ${driverStatsVal === '3' ? 'active' : ''}`}
                                        onClick={()=>driverStaticsValue('3')}>Monthly</Button>
                                    </Grid2>
                                </Grid2>

                                <TabPanel value={value} index={0} dir={theme.direction}>
                                    {chartData && (
                                        <BarChart
                                            xAxis={[{ scaleType: 'band', data: chartData.labels }]}
                                            series={chartData.seriesData}
                                            width={500}
                                            height={300}
                                        />
                                    )}
                                </TabPanel>

                                <TabPanel value={value} index={1} dir={theme.direction}>
                                    {chartData && (
                                        <BarChart
                                            xAxis={[{ scaleType: 'band', data: chartData.labels }]}
                                            series={chartData.seriesData}
                                            width={500}
                                            height={300}
                                        />
                                    )}
                                </TabPanel>

                                {value==0 && 
                                    <Grid2 container spacing={4} sx={{backgroundColor:'#F9F9F9'}}>
                                        <Grid2 item sx={{display:'flex'}}>
                                            <Grid2 item>
                                                <FiberManualRecordIcon style={{ fontSize: '16px', color:'#02B2AF' }}/>
                                            </Grid2>
                                            <Grid2 item>
                                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Total Drivers</Typography>
                                            </Grid2>
                                        </Grid2>
                                        <Grid2 item sx={{display:'flex'}}>
                                            <Grid2 item>
                                                <FiberManualRecordIcon style={{ fontSize: '16px', color:'#2E96FF' }}/>
                                            </Grid2>
                                            <Grid2 item>
                                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Active Drivers</Typography>
                                            </Grid2>
                                        </Grid2>
                                        <Grid2 item sx={{display:'flex'}}>
                                            <Grid2 item>
                                                <FiberManualRecordIcon style={{ fontSize: '16px', color:'#B800D8' }}/>
                                            </Grid2>
                                            <Grid2 item>
                                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Inactive Drivers</Typography>
                                            </Grid2>
                                        </Grid2>
                                        {/* <Grid2 item sx={{display:'flex'}}>
                                            <Grid2 item>
                                                <FiberManualRecordIcon style={{ fontSize: '16px', color:'#60009B' }}/>
                                            </Grid2>
                                            <Grid2 item>
                                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Inactive Drivers</Typography>
                                            </Grid2>
                                        </Grid2> */}
                                    </Grid2>
                                }
                                {value==1 && 
                                    <Grid2 container spacing={4} sx={{backgroundColor:'#F9F9F9'}}>
                                        <Grid2 item sx={{display:'flex'}}>
                                            <Grid2 item>
                                                <FiberManualRecordIcon style={{ fontSize: '16px', color:'#02B2AF' }}/>
                                            </Grid2>
                                            <Grid2 item>
                                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Total Users</Typography>
                                            </Grid2>
                                        </Grid2>
                                        <Grid2 item sx={{display:'flex'}}>
                                            <Grid2 item>
                                                <FiberManualRecordIcon style={{ fontSize: '16px', color:'#2E96FF' }}/>
                                            </Grid2>
                                            <Grid2 item>
                                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Active Users</Typography>
                                            </Grid2>
                                        </Grid2>
                                        <Grid2 item sx={{display:'flex'}}>
                                            <Grid2 item>
                                                <FiberManualRecordIcon style={{ fontSize: '16px', color:'#B800D8' }}/>
                                            </Grid2>
                                            <Grid2 item>
                                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Inactive Users</Typography>
                                            </Grid2>
                                        </Grid2>
                                    </Grid2>
                                }
                            </Grid2>
                        </Grid2>
                    </Grid2>

                    <Grid2 item size={6} className="mainBox" sx={{marginTop:'1%'}}>
                        <Grid2 item container size={12}>
                            <Grid2 item size={6}>
                                <Typography sx={{fontSize:'24px', color:'#1A1E25', paddingTop:'1%'}}>Downloads' Statistics</Typography>
                            </Grid2>
                            <Grid2 item size={6}>

                                <AppBar position="static" sx={{minHeight:"10px", maxHeight:'48px', borderRadius:'8px', backgroundColor:'#F9F9F9', padding:'4px', boxShadow:'none'}}>
                                    <Tabs value={downloadTab} onChange={handleDownloadStaticsChange} indicatorColor="secondary"
                                    textColor="inherit" variant="fullWidth" aria-label="full width tabs example" >
                                        <Tab label="Driver Statics" className={downloadTab === 0 ? 'tabHeader active' : 'tabHeader'}
                                            sx={{textTransform:'none'}} {...a11yDownloadProps(0)} />

                                        <Tab label="Rider Statics" className={downloadTab === 1 ? 'tabHeader active' : 'tabHeader'}
                                        sx={{textTransform:'none'}} {...a11yDownloadProps(1)} />
                                    </Tabs>
                                </AppBar>
                            </Grid2>
                        </Grid2> 
                        <hr/>
                        <Grid2 item>

                            <Grid2 container>
                                <Grid2 item sx={{marginLeft:'auto'}}>
                                    <Button className = {`daysWeeklyMonthly ${downloadStatsVal === '1' ? 'active' : ''}`}
                                    onClick={()=>downloadStaticsValue('1')}>Days</Button>

                                    <Button className={`daysWeeklyMonthly ${downloadStatsVal === '2' ? 'active' : ''}`} 
                                    onClick={()=>downloadStaticsValue('2')}>Weekly</Button>

                                    <Button className={`daysWeeklyMonthly ${downloadStatsVal === '3' ? 'active' : ''}`}
                                    onClick={()=>downloadStaticsValue('3')}>Monthly</Button>
                                </Grid2>
                            </Grid2>

                            <TabPanel value={downloadTab} index={0} dir={theme.direction}>
                                {downloadChartData && (
                                    <BarChart
                                        xAxis={[{ scaleType: 'band', data: downloadChartData.labels }]}
                                        series={downloadChartData.seriesData}
                                        width={500}
                                        height={300}
                                    />
                                )}
                            </TabPanel>

                            <TabPanel value={downloadTab} index={1} dir={theme.direction}>
                                {downloadChartData && (
                                    <BarChart
                                        xAxis={[{ scaleType: 'band', data: downloadChartData.labels }]}
                                        series={downloadChartData.seriesData}
                                        width={500}
                                        height={300}
                                    />
                                )}
                            </TabPanel>

                            <Grid2 container spacing={8} sx={{backgroundColor:'#F9F9F9', justifyContent:'center', padding:'2px'}}>
                                <Grid2 item sx={{display:'flex'}}>
                                    <Grid2 item>
                                        <FiberManualRecordIcon style={{ fontSize: '16px', color:'#02B2AF' }}/>
                                    </Grid2>
                                    <Grid2 item>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>Android</Typography>
                                    </Grid2>
                                </Grid2>
                                <Grid2 item sx={{display:'flex'}}>
                                    <Grid2 item>
                                        <FiberManualRecordIcon style={{ fontSize: '16px', color:'#2E96FF' }}/>
                                    </Grid2>
                                    <Grid2 item>
                                        <Typography sx={{color:'#83888E', fontSize:'14px'}}>iOS</Typography>
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Grid2>

                <Grid2 className="mainBox" sx={{marginTop:'1%'}}>

                    <Grid2 item container size={12}>
                        <Grid2 item size={5}>
                            <Typography sx={{fontSize:'24px', color:'#1A1E25', paddingTop:'1%'}}>Booking Statistics</Typography>
                        </Grid2>
                        <Grid2 item size={7}>
                            <AppBar position="static" sx={{minHeight:"10px", maxHeight:'48px', borderRadius:'8px', backgroundColor:'#F9F9F9', padding:'4px', boxShadow:'none'}}>
                                <Tabs value={bookingTab} onChange={handleBookingStaticsChange} indicatorColor="secondary"
                                textColor="inherit" variant="fullWidth" aria-label="full width tabs example" >
                                    <Tab label="Scheduled Rides" className={bookingTab === 0 ? 'tabHeader active' : 'tabHeader'} sx={{textTransform:'none'}} {...a11yPropsBooking(0)} />
                                    <Tab label="On-Demand Rides" className={bookingTab === 1 ? 'tabHeader active' : 'tabHeader'} sx={{textTransform:'none'}} {...a11yPropsBooking(1)} />
                                    <Tab label="Completed Rides" className={bookingTab === 2 ? 'tabHeader active' : 'tabHeader'} sx={{textTransform:'none'}} {...a11yPropsBooking(2)} />
                                    {/* <Tab label="Scheduled Rides" className={bookingTab === 1 ? 'tabHeader active' : 'tabHeader'} sx={{textTransform:'none'}} {...a11yPropsBooking(1)} /> */}
                                    <Tab label="Cancelled Rides" className={bookingTab === 3 ? 'tabHeader active' : 'tabHeader'} sx={{textTransform:'none'}} {...a11yPropsBooking(3)} />
                                    
                                </Tabs>
                            </AppBar>
                        </Grid2>
                    </Grid2>

                    <Grid2 item container size={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={[
                                'DatePicker',
                                'MobileDatePicker',
                                'DesktopDatePicker',
                                'StaticDatePicker',
                                ]}
                            >
                                <Grid2 container>
                                    <Grid2 item>
                                        <DemoItem label="">
                                            <DatePicker sx={{height:'40px'}} defaultValue={dayjs(bookingStartDate)} onChange={(newValue) => setBookingStartDate(newValue)} />
                                        </DemoItem>
                                    </Grid2>
                                    <Grid2 item>
                                        <DemoItem label="">
                                            <DatePicker sx={{height:'60px'}} defaultValue={dayjs(bookingEndDate)} onChange={(newValue) => setBookingEndDate(newValue)} />
                                        </DemoItem>
                                    </Grid2>
                                </Grid2>
                                
                                
                            </DemoContainer>
                        </LocalizationProvider>
                    </Grid2>
                    <hr/>

                    <Grid2 item container size={12} spacing={2}>
                        <Grid2 item size={6}>
                            <TabPanel value={bookingTab} index={0} dir={theme.direction}>
                                <Grid2 sx={{border:'1px solid #9CE3C8', borderRadius:'16px'}}>
                                    <Typography sx={{paddingTop:'2%', paddingLeft:'3%', fontSize:'18px'}}>Scheduled Rides</Typography>
                                    
                                    <LineChart
                                        xAxis={[{ scaleType: 'point', data: bookingChartData?.labels || [] }]}
                                        series={[
                                            {
                                            data: bookingChartData?.seriesData || [],
                                            label:'Ride Count'
                                            },
                                        ]} width={500} height={460}
                                    />
                                </Grid2>
                            </TabPanel>

                            <TabPanel value={bookingTab} index={1} dir={theme.direction}>
                                <Grid2 sx={{border:'1px solid #9CE3C8', borderRadius:'16px'}}>
                                    <Typography sx={{paddingTop:'2%', paddingLeft:'3%', fontSize:'18px'}}>On-Demand Rides</Typography>
                                    
                                    <LineChart
                                        xAxis={[{ scaleType: 'point', data: bookingChartData?.labels || [] }]}
                                        series={[
                                            {
                                            data: bookingChartData?.seriesData || [],
                                            label:'Ride Count'
                                            },
                                        ]} width={500} height={460}
                                    />
                                </Grid2>
                            </TabPanel>
                            <TabPanel value={bookingTab} index={2} dir={theme.direction}>
                                <Grid2 sx={{border:'1px solid #9CE3C8', borderRadius:'16px'}}>
                                    <Typography sx={{paddingTop:'2%', paddingLeft:'3%', fontSize:'18px'}}>Completed Rides</Typography>
                                    
                                    <LineChart
                                        xAxis={[{ scaleType: 'point', data: bookingChartData?.labels || [] }]}
                                        series={[
                                            {
                                            data: bookingChartData?.seriesData || [],
                                            label:'Ride Count'
                                            },
                                        ]} width={500} height={460}
                                    />
                                </Grid2>
                            </TabPanel>
                            <TabPanel value={bookingTab} index={3} dir={theme.direction}>
                                <Grid2 sx={{border:'1px solid #9CE3C8', borderRadius:'16px'}}>
                                    <Typography sx={{paddingTop:'2%', paddingLeft:'3%', fontSize:'18px'}}>Cancelled Rides</Typography>
                                    
                                    <LineChart
                                        xAxis={[{ scaleType: 'point', data: bookingChartData?.labels || [] }]}
                                        series={[
                                            {
                                            data: bookingChartData?.seriesData || [],
                                            label:'Ride Count'
                                            },
                                        ]} width={500} height={460}
                                    />
                                </Grid2>
                            </TabPanel>
                            
                        </Grid2>

                        <Grid2 item size={6}>
                            {isLoaded ? (
                                <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={20} onLoad={onLoad} onIdle={()=> { setBound(true)}} onUnmount={onUnmount}>
                                    {latLngData.length > 0 && latLngData.map((marker) => {
                                        return(
                                            <Marker
                                                key={marker.id}
                                                position={{ lat: marker.lat, lng: marker.lng }}
                                                title={marker.request_id} 
                                                // label={{
                                                //     text: 'Request ID: '+marker.id.toString(),
                                                //     color: '#000000',
                                                //     fontSize: '12px',
                                                //     fontWeight: 'bold',
                                                //     className: 'marker-label'
                                                // }}
                                                icon={{
                                                    url: latLngMarker,
                                                    scaledSize: new window.google.maps.Size(20, 20),
                                                    // labelOrigin: new window.google.maps.Point(10, -10)
                                                }}
                                            />
                                        )
                                    } )}
                                </GoogleMap>
                            ): (<>Loading</>)}
                        </Grid2>
                    </Grid2>
                    
                </Grid2>

                {showDriverEarnings && <Grid2 className="mainBox" sx={{marginTop:'1%'}}>
                    <Grid2 item container size={12}>
                        <Grid2 item size={6}>
                            <Typography sx={{fontSize:'24px', color:'#1A1E25', paddingTop:'1%'}}>Driver's Earning Statistics</Typography>
                        </Grid2>
                        <Grid2 item size={6} sx={{}}>
                            
                        </Grid2>
                    </Grid2>
                    <hr/>
                    
                    <Grid2 item>
                        <Grid2 container>
                            <Grid2 item sx={{marginLeft:'auto'}}>
                                <Button className = {`daysWeeklyMonthly ${driverEarningVal === '1' ? 'active' : ''}`}
                                onClick={()=>driverEarningStaticsValue('1')}>Days</Button>

                                <Button className={`daysWeeklyMonthly ${driverEarningVal === '2' ? 'active' : ''}`} 
                                onClick={()=>driverEarningStaticsValue('2')}>Weekly</Button>

                                <Button className={`daysWeeklyMonthly ${driverEarningVal === '3' ? 'active' : ''}`}
                                onClick={()=>driverEarningStaticsValue('3')}>Monthly</Button>
                            </Grid2>
                        </Grid2>
                        <Grid2 item size={12}>
                            <LineChart
                                xAxis={[{ scaleType: 'point', data: earningChartData?.labels || [] }]}
                                series={[
                                    {
                                    data: earningChartData?.seriesData || [],
                                    color: '#6BA6FF',
                                    },
                                ]}
                                height={300}
                            />
                        </Grid2>

                    </Grid2>

                </Grid2>}

                <Grid2 className="mainBox" sx={{marginTop:'1%'}}>
                    <Grid2 item>
                        <Typography sx={{fontSize:'24px', color:'#1A1E25', paddingTop:'1%'}}>Latest Users</Typography>
                    </Grid2>
                    <hr/>
                    <Grid2 item>
                        <AppBar position="static" sx={{minHeight:"10px", maxHeight:'48px', borderRadius:'8px', backgroundColor:'#F9F9F9', padding:'4px', boxShadow:'none', width:'20%'}}>
                            <Tabs value={latestUserTab} onChange={handleLatestUserChange} indicatorColor="secondary"
                            textColor="inherit" variant="fullWidth" aria-label="full width tabs example" >
                                <Tab label="Driver" className={latestUserTab === 0 ? 'tabHeader active' : 'tabHeader'} sx={{textTransform:'none'}} {...a11yPropsLatestUser(0)} />
                                <Tab label="Rider" className={latestUserTab === 1 ? 'tabHeader active' : 'tabHeader'} sx={{textTransform:'none'}} {...a11yPropsLatestUser(1)} />
                            </Tabs>
                        </AppBar>
                    </Grid2>

                    <Grid2 item>
                        <TabPanel value={latestUserTab} index={0} dir={theme.direction}>
                            <TableContainer className="table-container">
                                <Table stickyHeader className="scrollable-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell component="th" align="center" className="table-header" style={{ width: '5%' }}>
                                                <TableSortLabel
                                                    active={orderBy === 'driver_id'}
                                                    direction={orderBy === 'driver_id' ? order : 'asc'}
                                                    onClick={() => handleRequestSort('driver_id')}
                                                >
                                                    ID
                                                </TableSortLabel>
                                            </TableCell>
                                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Driver</TableCell>
                                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Email</TableCell>
                                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {paginatedData && (paginatedData).map((row) => (
                                            <TableRow>
                                                <TableCell>{row.driver_id}</TableCell>
                                                <TableCell style={{justifyItems:'center'}}>
                                                    <Grid2 container sx={{ width:'auto', minWidth:'180px'}}>
                                                        <Grid2>
                                                            <Avatar sx={{borderColor:'#0065FF', border:1}} alt={row.driver_name} src={row.driver_image} ></Avatar>
                                                        </Grid2>
                                                        <Grid2 item sx={{ml:'8px',textAlign:'left'}}>
                                                            <Grid2>
                                                                <Typography>{row.driver_name}</Typography>
                                                            </Grid2>
                                                            <Grid2>
                                                                <Typography sx={{color:'#83888E', fontSize:'12px'}}>{row.phone_number}</Typography>
                                                            </Grid2>
                                                        </Grid2>
                                                    </Grid2>
                                                </TableCell>
                                                <TableCell>{row.email}</TableCell>
                                                <TableCell>
                                                    <Button
                                                        variant="contained"
                                                        style={{
                                                            backgroundColor: row.driver_current_status==0 ? '#F9E9E9' : '#E7F8F2',
                                                            color: row.driver_current_status==0 ? '#D14545' : '#0DBA78',
                                                            textTransform: 'none',
                                                            pointerEvents: 'none',
                                                            borderRadius: '6px',
                                                            minWidth: '60px',
                                                            border:'none',
                                                            boxShadow: 'none',
                                                            fontFamily: 'Poppins',
                                                            marginRight:'16px'
                                                        }}
                                                    >
                                                        <FiberManualRecordIcon style={{ fontSize: '16px' }}/> {row.driver_current_status == 0 ? 'Offline' : 'Online'}
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <div className="custom-pagination">
                                    <div className="pagination-info">
                                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                                            (page + 1) * rowsPerPage,
                                            rows.length
                                        )} of ${rows.length} entries`}
                                    </div>
                                    <div className="pagination-controls">
                                        <button
                                            onClick={() => handleChangePage(null, page - 1)}
                                            disabled={page === 0}
                                            className="pagination-arrow"
                                        >
                                            <img src={prevIcon} alt="Previous" />
                                        </button>
                            
                                        <div className="pagination-numbers">
                                            {page > 1 && (
                                                <>
                                                    <button onClick={() => handleChangePage(null, 0)} className="pagination-number">
                                                        1
                                                    </button>
                                                    <span className="pagination-dots">...</span>
                                                </>
                                            )}
                                            {[...Array(Math.ceil(rows.length / rowsPerPage))]
                                                .map((_, index) => index)
                                                .filter((index) => index >= page - 1 && index <= page + 1) // Show only previous, current, and next page
                                                .map((index) => (
                                                    <button
                                                        key={index}
                                                        onClick={() => handleChangePage(null, index)}
                                                        className={`pagination-number ${page === index ? 'active' : ''}`}
                                                    >
                                                        {index + 1}
                                                    </button>
                                            ))}

                                            {page < Math.ceil(rows.length / rowsPerPage) - 2 && (
                                                <>
                                                    <span className="pagination-dots">...</span>
                                                    <button
                                                        onClick={() => handleChangePage(null, Math.ceil(rows.length / rowsPerPage) - 1)}
                                                        className="pagination-number"
                                                    >
                                                        {Math.ceil(rows.length / rowsPerPage)}
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                        <button
                                            onClick={() => handleChangePage(null, page + 1)}
                                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                                            className="pagination-arrow"
                                        >
                                            <img src={nextIcon} alt="Next" />
                                        </button>
                                    </div>
                                </div>
                            </TableContainer>
                        </TabPanel>
                        
                        <TabPanel value={latestUserTab} index={1} dir={theme.direction}>
                            <TableContainer className="table-container">
                                <Table stickyHeader className="scrollable-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell component="th" align="center" className="table-header" style={{ width: '5%' }}>
                                                <TableSortLabel
                                                    active={orderBy === 'user_id'}
                                                    direction={orderBy === 'user_id' ? order : 'asc'}
                                                    onClick={() => handleRequestSort('user_id')}
                                                >
                                                    ID
                                                </TableSortLabel>
                                            </TableCell>
                                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>User</TableCell>
                                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Email</TableCell>
                                            {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell> */}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {paginatedData && (paginatedData).map((row) => (
                                            <TableRow>
                                                <TableCell>{row.user_id}</TableCell>
                                                <TableCell style={{justifyItems:'center'}}>
                                                    <Grid2 container sx={{ width:'auto', minWidth:'180px'}}>
                                                        <Grid2>
                                                            <Avatar sx={{borderColor:'#0065FF', border:1}} alt={row.user_name} src={row.user_image} ></Avatar>
                                                        </Grid2>
                                                        <Grid2 item sx={{ml:'8px',textAlign:'left'}}>
                                                            <Grid2>
                                                                <Typography>{row.user_name}</Typography>
                                                            </Grid2>
                                                            {/* <Grid2>
                                                                <Typography sx={{color:'#83888E', fontSize:'12px'}}>{row.phone_number}</Typography>
                                                            </Grid2> */}
                                                        </Grid2>
                                                    </Grid2>
                                                </TableCell>
                                                <TableCell>{row.user_email}</TableCell>
                                                {/* <TableCell>
                                                    <Button
                                                        variant="contained"
                                                        style={{
                                                            backgroundColor: row.driver_current_status==0 ? '#F9E9E9' : '#E7F8F2',
                                                            color: row.driver_current_status==0 ? '#D14545' : '#0DBA78',
                                                            textTransform: 'none',
                                                            pointerEvents: 'none',
                                                            borderRadius: '6px',
                                                            minWidth: '60px',
                                                            border:'none',
                                                            boxShadow: 'none',
                                                            fontFamily: 'Poppins',
                                                            marginRight:'16px'
                                                        }}
                                                    >
                                                        <FiberManualRecordIcon style={{ fontSize: '16px' }}/> {row.driver_current_status == 0 ? 'Offline' : 'Online'}
                                                    </Button>
                                                </TableCell> */}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <div className="custom-pagination">
                                    <div className="pagination-info">
                                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                                            (page + 1) * rowsPerPage,
                                            rows.length
                                        )} of ${rows.length} entries`}
                                    </div>
                                    <div className="pagination-controls">
                                        <button
                                            onClick={() => handleChangePage(null, page - 1)}
                                            disabled={page === 0}
                                            className="pagination-arrow"
                                        >
                                            <img src={prevIcon} alt="Previous" />
                                        </button>
                            
                                        <div className="pagination-numbers">
                                            {page > 1 && (
                                                <>
                                                    <button onClick={() => handleChangePage(null, 0)} className="pagination-number">
                                                        1
                                                    </button>
                                                    <span className="pagination-dots">...</span>
                                                </>
                                            )}
                                            {[...Array(Math.ceil(rows.length / rowsPerPage))]
                                                .map((_, index) => index)
                                                .filter((index) => index >= page - 1 && index <= page + 1) // Show only previous, current, and next page
                                                .map((index) => (
                                                    <button
                                                        key={index}
                                                        onClick={() => handleChangePage(null, index)}
                                                        className={`pagination-number ${page === index ? 'active' : ''}`}
                                                    >
                                                        {index + 1}
                                                    </button>
                                            ))}

                                            {page < Math.ceil(rows.length / rowsPerPage) - 2 && (
                                                <>
                                                    <span className="pagination-dots">...</span>
                                                    <button
                                                        onClick={() => handleChangePage(null, Math.ceil(rows.length / rowsPerPage) - 1)}
                                                        className="pagination-number"
                                                    >
                                                        {Math.ceil(rows.length / rowsPerPage)}
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                        <button
                                            onClick={() => handleChangePage(null, page + 1)}
                                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                                            className="pagination-arrow"
                                        >
                                            <img src={nextIcon} alt="Next" />
                                        </button>
                                    </div>
                                </div>
                            </TableContainer>
                        </TabPanel>
                    </Grid2>
                </Grid2>
                </>
            )}

            {clientDemoTypeFilter === '2' && (
                <>
                    <ShuttleDashboard cityFilter={cityFilter} />
                </>
            )}
                
        </div>
    )
}

export default MainDashboard;